import BusinessRoutePath from 'app/business-app/BusinessRoutePath';
import Body from 'app/shared/components/typography/body/Body';
import styledFuncs from 'app/styles/styledFuncs';
import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components/macro';
import ProfileLinks from './components/ProfileLinks';

const LinksContainer = styled.div`
  margin: ${styledFuncs.pad(1.5)} !important;
`;
export default function SelectBusinessType(): JSX.Element {
  const history = useHistory();
  const links = [
    {
      text: 'Individual',
      pageNum: 3,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      redirectUrl: BusinessRoutePath.CREATE_PERSONAL_PROFILE,
    },
    {
      text: 'Business',
      pageNum: 4,
      redirectUrl: BusinessRoutePath.CREATE_PROFILE,
    },
  ];
  const navigateToLink = (link: string) => {
    history.push(link, true);
  };
  return (
    <>
      <LinksContainer>
        <Body color="primary">
          Please select one of the following
        </Body>
        {links.map(link => (
          <ProfileLinks
            text={link.text}
            key={link.pageNum}
            disabled={false}
            onClick={() => navigateToLink(link.redirectUrl)}
          />
        ))}
      </LinksContainer>
    </>
  );
}
